import $ from 'jquery';
import 'jquery.cookie';
import * as Cookies from 'js-cookie';

var formatter = (function () {
	function addLeadingZeroIfMissing(number) {
		if (number <= 9) {
			return '0' + number;
		}

		return number;
	}

	var formatDate = function (date) {
		if ($.type(date) === 'string') {
			date = new Date(date);
		}

		return (
			addLeadingZeroIfMissing(date.getDate()) +
			'.' +
			addLeadingZeroIfMissing(date.getMonth() + 1) +
			'.' +
			date.getFullYear()
		);
	};

	var formatIsoDate = function (date) {
		if ($.type(date) === 'string') {
			date = new Date(date);
		}

		return (
			date.getFullYear() +
			'-' +
			addLeadingZeroIfMissing(date.getMonth() + 1) +
			'-' +
			addLeadingZeroIfMissing(date.getDate())
		);
	};

	var formatDateTime = function (dateTime) {
		if ($.type(dateTime) === 'string') {
			dateTime = new Date(dateTime);
		}

		let date = ('0' + dateTime.getDate()).slice(-2);
		let month = ('0' + (dateTime.getMonth() + 1)).slice(-2);
		let year = dateTime.getFullYear();
		let hours = ('0' + dateTime.getHours()).slice(-2);
		let minutes = ('0' + dateTime.getMinutes()).slice(-2);

		return date + '.' + month + '.' + year + ' ' + hours + ':' + minutes;
	};

	var formatNumber = function (number) {
		if (!number) {
			return '0';
		}

		return number.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ' ');
	};

	return {
		formatDate: formatDate,
		formatIsoDate: formatIsoDate,
		formatDateTime: formatDateTime,
		formatNumber: formatNumber,
	};
})();

/**
 * @param string: string
 * @param length: int
 * @return string
 */
var abbreviate = function (string, length) {
	if (string.length <= length) {
		return string;
	}

	return string.substring(0, length - 3) + '...';
};

/**
 * @param price: float
 * @param decimalCount: int
 * @param suffix: string
 */
var formatMoney = function (amount, decimalCount, suffix) {
	decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
	suffix = suffix == null ? '&nbsp;Kč' : '';

	var parts = amount.toFixed(decimalCount).split('.');
	var decimalPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '$&&nbsp;');

	return decimalPart + (parts[1] !== undefined ? ',' + parts[1] : '') + suffix;
};

var translate = (function () {
	/**
	 * Select translation form based on the count.
	 *
	 * @param {{
	 *     formSingle: string,
	 *     formFew: string,
	 *     formMany: string
	 * }} forms Translation forms.
	 * @param {int} count Items count.
	 */
	var selectForm = function (forms, count) {
		if (count === 1) {
			return forms.formSingle;
		}

		if (count >= 2 && count <= 4) {
			return forms.formFew;
		}

		return forms.formMany;
	};

	return {
		selectForm: selectForm,
	};
})();

var api = (function ($) {
	var settings = {};

	var init = function (options) {
		$(document).ajaxError(function (event, xhr) {
			var data = xhr.responseJSON;
			if (!data || data.errors === undefined) {
				return;
			}
			var errorCodes = data.errors.map(function (error) {
				return error.code;
			});

			if (
				$.inArray('missing-access-token', errorCodes) !== -1 ||
				$.inArray('authentication-inactive-security-token', errorCodes) !== -1 ||
				$.inArray('authentication-unknown-security-token', errorCodes) !== -1 ||
				$.inArray('authentication-invalid-security-token-header', errorCodes) !== -1 ||
				$.inArray('authentication-missing-security-token', errorCodes) !== -1
			) {
				Cookies.withConverter({
					write: function (value, name) {
						return value;
					},
				}).set('login-redirect-url', window.location.pathname + window.location.search + window.location.hash, {
					expires: 1,
					path: '/',
				});
				window.location = '/login';
			}
		});

		settings = $.extend(
			{
				apiPrefix: $('.app-settings').data('api-prefix'),
				userId: $('.user-id').data('user-id'),
				accessToken: $.cookie('accessToken'),
			},
			options
		);
	};

	var getAjaxOptions = function (url) {
		return {
			url: settings.apiPrefix + url,
			headers: {
				Authorization: 'Bearer ' + settings.accessToken,
				'Content-Type': 'application/json',
			},
			contentType: 'application/json; charset=UTF-8',
			dataType: 'json',
		};
	};

	var getUserId = function () {
		return settings.userId;
	};

	var call = function (method, url, data) {
		return $.ajax(
			$.extend(getAjaxOptions(url), {
				method: method,
				data: JSON.stringify(data),
				error: function () {
					$(document).trigger('api.error');
				},
			})
		);
	};

	return {
		init: init,
		getAjaxOptions: getAjaxOptions,
		getUserId: getUserId,
		get: function (url) {
			return call('get', url);
		},
		post: function (url, data) {
			return call('post', url, data);
		},
		put: function (url, data) {
			return call('put', url, data);
		},
		delete: function (url) {
			return call('delete', url);
		},
	};
})(jQuery);

/**
 * Modal dialogs feature.
 */
var modal = (function ($) {
	var settings = {};
	var modalClass;

	var init = function (options) {
		var container = options && options.container ? options.container : $('.modal');
		settings = $.extend(
			{
				components: $('.modal-component'),
				container: container,
				header: container.find('.modal-header h2'),
				contentContainer: container.find('.modal-content'),
				closeButtonSelector: '.btn-modal-close',
			},
			options
		);
		$(document).keyup(function (e) {
			// Esc key pressed
			if (e.keyCode === 27) {
				hide();
			}
		});
	};

	var show = function (content) {
		modalClass = settings.container.attr('class');
		settings.header.html($(content).data('modal-header'));
		settings.contentContainer.html($(content).clone().css('display', 'block'));
		settings.container.addClass($(content).data('modal-class'));
		settings.container.find(settings.closeButtonSelector).unbind('click').click(hide);
		settings.components.show();
		$(document).trigger('modal.shown');
	};

	var hide = function () {
		settings.components.hide();
		settings.contentContainer.html('');
		settings.container.attr('class', modalClass);
		$(document).trigger('modal.hidden');
	};

	return {
		init: init,
		show: show,
		hide: hide,
	};
})(jQuery);

/**
 * Flash messages feature.
 */
var flashMessage = (function ($) {
	var settings = {};
	var timer = null;

	var init = function (options) {
		var container = options && options.container ? options.container : $('.flash-message');
		settings = $.extend(
			{
				container: container,
				messageContainer: container.find('.message'),
				contentContainer: container.find('.message-content'),
				closeButton: container.find('.btn-message-close'),
				types: 'success error danger warning info',
				visibleClass: 'visible',
				timeout: 10000,
			},
			options
		);
		settings.closeButton.click(hide);

		if (settings.container.hasClass(settings.visibleClass)) {
			startTimer();
		}
	};

	var show = function (type, content) {
		settings.container.addClass(settings.visibleClass);
		settings.messageContainer.removeClass(settings.types).addClass(type);
		settings.contentContainer.html(content);
		startTimer();
		$(document).trigger('flash.shown');
	};

	var hide = function () {
		settings.container.removeClass(settings.visibleClass);
		clearTimer();
		$(document).trigger('flash.hidden');
	};

	var startTimer = function () {
		clearTimer();
		timer = setTimeout(hide, settings.timeout);
	};

	var clearTimer = function () {
		if (!timer) {
			return;
		}

		clearTimeout(timer);
		timer = null;
	};

	return {
		init: init,
		show: show,
		hide: hide,
	};
})(jQuery);

/**
 * Staging messages feature.
 */
var stickyMessage = (function ($) {
	var initMessage = function ($container) {
		let dismissCookieName = $container.data('sticky-message-cookie');
		let dismissRemember = !!dismissCookieName;

		if (dismissRemember && $.cookie(dismissCookieName + '-hidden') === 'true') {
			return;
		}

		// show the message
		$container.addClass('visible');

		// allow the user to dismiss the message
		$container.find('.btn-message-close').click(() => {
			$container.remove();
			if (dismissRemember) {
				$.cookie(dismissCookieName + '-hidden', 'true', { expires: 30 });
			}
		});
	};

	var initAll = function () {
		$('.sticky-message').each(function () {
			initMessage($(this));
		});
	};

	var showSingle = function (type, content) {
		let $container = $('<div class="sticky-message new-layout" />');
		let $message = $('<div class="message" />').addClass(type);
		$message.append($('<div class="message-content" />').html(content));
		$message.append($('<button type="button" class="btn-message-close">zavřít</button>'));
		$container.append($message);

		$('body').append($container);

		initMessage($container);
	};

	return {
		init: initAll,
		show: showSingle,
	};
})(jQuery);

/**
 * Badges feature.
 */
var badge = (function ($) {
	var timers = [];

	var show = function (element, iconClass, textProperty, timeout) {
		$(element)
			.html('<span class="icon ' + iconClass + '"></span><span>' + $(element).data(textProperty) + '</span>')
			.css('display', 'inline-block');

		clearTimer(element);

		if (!timeout) {
			return;
		}

		timers[element] = setTimeout(function () {
			hide(element);
		}, timeout);
	};

	var hide = function (element) {
		clearTimer(element);
		$(element).hide();
	};

	var clearTimer = function (key) {
		if (!timers[key]) {
			return;
		}

		clearTimeout(timers[key]);
		timers[key] = null;
	};

	return {
		show: show,
		hide: hide,
	};
})(jQuery);

/**
 * Retrieve URL param by name.
 */
var getURLParam = function (name) {
	if ((name = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)').exec(window.location.search))) {
		return decodeURIComponent(name[1]);
	}
};

var nl2br = function (str) {
	if (typeof str === 'undefined' || str === null) {
		return '';
	}
	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
};

var br2nl = function (str) {
	if (typeof str === 'undefined' || str === null) {
		return '';
	}
	return (str + '').replace(/<br>/g, '\n');
};

export {
	formatter,
	abbreviate,
	formatMoney,
	translate,
	api,
	modal,
	flashMessage,
	stickyMessage,
	badge,
	getURLParam,
	nl2br,
	br2nl,
};
